import { useState } from "react";
import { Icon } from "../components/Icon";
import type { BlockViewProps } from "./types";

/**
 * Fallback obligatorio.
 *
 * Un `type` que este frontend todavía no conoce no puede romper el stream ni
 * desaparecer en silencio: se pinta un desplegable con el JSON crudo, así que
 * el bloque se ve, se puede copiar y —si el contrato creció sin que la UI se
 * enterara— el desajuste salta a la vista en lugar de perderse.
 *
 * Es la red de seguridad del contrato: si aparece en pantalla, hay una
 * versión de la UI por detrás del backend.
 */
export function Unknown({ block }: BlockViewProps) {
  const [open, setOpen] = useState(false);
  const raw = JSON.stringify(block, null, 2);
  const id = "id" in block && typeof block.id === "string" ? block.id : "sin id";
  const type = "type" in block && typeof block.type === "string" ? block.type : "desconocido";

  return (
    <div className="atom atom--unknown unknown">
      <button
        type="button"
        className="unknown__head"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="unknown__icon" aria-hidden="true">
          <Icon name="alert" size="1rem" />
        </span>
        <span className="unknown__text">
          <span className="unknown__title">Bloque no reconocido</span>
          <span className="unknown__meta">
            <code className="u-mono">{type}</code>
            <span className="unknown__id u-mono">{id}</span>
          </span>
        </span>
        <span className="unknown__toggle u-label">{open ? "Ocultar JSON" : "Ver JSON"}</span>
      </button>
      {open ? <pre className="unknown__json u-mono">{raw}</pre> : null}
    </div>
  );
}

export default Unknown;
